import { ICellRendererParams } from 'ag-grid-community';

import { getAgGridTableCellData } from 'core/utils';
import { IPartBomItem } from 'partBoms/types';
import { PartImage } from 'parts/elements';

interface IProps extends ICellRendererParams {
  colId: string;
}

export const ImageCell = ({ colId = 'image', ...props }: IProps) => {
  const data = getAgGridTableCellData(props, colId) as IPartBomItem;

  if (!data) {
    return;
  }

  const part = data?.partArr;

  return part && part?.defaultImage ? (
    <PartImage url={part?.defaultImage?.url} alt={part?.defaultImage?.alt} />
  ) : null;
};
